import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms'

export function parsePriceAmount(value: unknown): number {
  if (value === null || value === undefined || value === '') {
    return NaN
  }

  return typeof value === 'string'
    ? parseFloat(String(value).replace(',', '.'))
    : Number(value)
}

export function isStrictlyPositivePriceAmount(value: unknown): boolean {
  const amount = parsePriceAmount(value)
  return Number.isFinite(amount) && amount > 0
}

export function strictlyPositivePriceAmountValidator(
  control: AbstractControl
): ValidationErrors | null {
  const raw = control.value
  if (raw === null || raw === undefined || raw === '') {
    return { required: true }
  }

  if (!isStrictlyPositivePriceAmount(raw)) {
    return { positivePrice: true }
  }

  return null
}

export function strictlyPositivePriceAmountValidatorFn(): ValidatorFn {
  return strictlyPositivePriceAmountValidator
}
